<template>
  <div class="InformationMy defBorderRadius">
    <div class="InformationMy_top">
      <el-tabs v-model="listParm.status" @tab-click="onSubmit">
        <el-tab-pane
          v-for="item in plazaessageStatus"
          :label="item.label"
          :name="item.value"
          :key="item.label"
        ></el-tab-pane>
      </el-tabs>
      <div class="desc">共 {{ parm.total }} 条信息</div>
    </div>
    <div class="list" :key="listParm.status">
      <el-table
        row-class-name="defTableRowStyle"
        header-row-class-name="defTableHeaderStyle"
        :data="list"
        style="width: 100%"
        v-loading="listLoading"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
      >
        <el-table-column label="信息">
          <template slot-scope="scope">
            <div style="padding-bottom: 18px;">
              <div
                @click="toDetail(scope.row.messageId)"
                class="pointer keep2lines"
                style="font-size: 14px; font-weight: 400; color: #262626"
                :style="
                  cellMouseData?.messageId == scope.row.messageId
                    ? { color: '#0062FF' }
                    : {}
                "
              >
                {{ scope.row.content }}
              </div>
              <imageBox v-if="scope.row.type === 1" :url="scope.row.url" style="margin-top: 8px;"/>
              <videoBox v-else-if="scope.row.type === 2" :imgUrl="scope.row.coverUrl" :url="scope.row.url" style="margin-top: 8px;"/>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="浏览" width="80" v-if="['1'].includes(listParm.status)">
          <template slot-scope="scope">
            <div>
              {{ scope.row.viewCount }}
            </div>
          </template>
        </el-table-column>
         <el-table-column label="评论" width="80" v-if="['1'].includes(listParm.status)">
          <template slot-scope="scope">
            <div>
              {{ scope.row.commentCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="发布时间"
          width="180"
          v-if="['1'].includes(listParm.status)"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.updatedAt | timeFormat("yyyy-mm-dd hh:MM:ss") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="80" v-if="['2'].includes(listParm.status)">
          <template slot-scope="scope">
            <el-tooltip effect="dark" placement="top" v-if="scope.row.rejectionReason">
              <div style="width: 300px" slot="content">
                {{ scope.row.rejectionReason }}
              </div>
              <div class="pointer rejectionReason">
                <span class="el-icon-ali-wodegoumai"></span>备注
              </div>
            </el-tooltip>
            <div class="pointer rejectionReason" v-else>
              <span class="el-icon-ali-wodegoumai"></span>备注
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          width="80"
          v-if="['0', '2'].includes(listParm.status)"
        >
          <template slot-scope="scope">
            <div v-html="plazaessageStatusRender(scope.row)"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="提交时间"
          width="180"
          v-if="['0', '2'].includes(listParm.status)"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.createdAt | timeFormat("yyyy-mm-dd hh:MM:ss") }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80"
          v-if="['0', '1'].includes(listParm.status)"
        >
          <template slot-scope="scope">
            <div @click="del(scope.row)" class="del">删除</div>
          </template>
        </el-table-column>
        <template slot="empty">
          <empty />
        </template>
      </el-table>
      <div class="pagination">
        <div class="pagination_left"></div>
        <el-pagination
          :current-page="parm.current"
          :page-sizes="[30, 40, 50, 60]"
          :page-size.sync="parm.size"
          popper-class="paginationTopStyle"
          background
          layout="total,  prev, pager, next, jumper"
          :total="parm.total"
          @size-change="sizeChange"
          @current-change="currentChange"
          :popper-options="{
            placement: 'top',
            boundariesPadding: 10,
          }"
        >
        </el-pagination>
      </div>
    </div>
    <messageDialog ref="messageDialogRef" @confirm="delSubmit" />
  </div>
</template>

<script>
import imageBox from "./components/imageBox.vue";
import videoBox from "./components/videoBox.vue";
import getList from "@/mixins/getList";
import selectData from "@/mixins/selectData";
import messageDialog from "@/components/messageDialog/messageDialog.vue";
import { mapActions } from "vuex";
export default {
  mixins: [getList, selectData],
  components: {
    messageDialog,
    imageBox,
    videoBox,
  },
  data() {
    return {
      listParm: {
        status: "1",
      },
      settingData: {},
      autoGetList: false,
    };
  },
  mounted() {
    const status = this.$route.query.status;
    if (status !== undefined) {
      this.listParm.status = status;
    }
    this.getList();
  },

  computed: {},
  methods: {
    ...mapActions("information", ["detailOnShow"]),
    onSubmit() {
      console.log(this.listParm);
      this.onSearch();
    },
    listApi(parm) {
      let data = { ...parm, ...this.listParm };

      return this.$api.getPlazaMessageMineList(data);
    },
    del(data) {
      this.settingData = data;
      this.$refs.messageDialogRef.onShow({
        type: "info",
        title: "提示",
        content: "是否删除信息?",
        confirmText: "确定删除",
      });
    },
    delSubmit() {
      this.$api
        .deletePlazaMessage({
          messageId: this.settingData.messageId,
        })
        .then((res) => {
          this.$message.success("删除成功");
          this.onSearch();
        });
      this.settingData = {};
    },
    
    toDetail(id) {
      this.detailOnShow(id);
    },
  },
};
</script>

<style scoped lang="scss">
.InformationMy {
  background: #ffffff;
  &_top {
    @include tabsStyle;
  }
  .desc {
    height: 44px;
    font-size: 12px;
    font-weight: 350;
    line-height: normal;
    color: #666666;
    padding: 0 16px;
    display: flex;
    align-items: center;
  }
  .list {
    padding: 0 16px;
  }
  .pagination {
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: space-between;
  }
  .del {
    cursor: pointer;
    &:hover {
      color: #0062ff;
    }
  }
  .rejectionReason {
    font-size: 14px;
    font-weight: normal;
    line-height: 0px;
    display: flex;
    align-items: center;
    color: #666666;
    gap: 4px;
  }
}
</style>
